<template>
    <div class="footer-container">
        <el-footer height="">
            <div class="yw_bq"> Copyright © 2017 慈脉 V:{{ version }} 备案号： <a href="http://www.beian.miit.gov.cn/" target="_blank">赣ICP备19007744号</a>
                <a target="_blank"
                href="https://xyt.xcc.cn/getpcInfo?sn=1589954693172277248&amp;certType=8&amp;url=*.cimaizhongyi.com&amp;language=CN"
                class="ssl-logo"><img src="https://program.xinchacha.com/xyt/xcc_small_ssl.png" style="width: 18px;"/></a>
            </div>
      </el-footer>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters(["version"]),
    }
};
</script>
<style scoped lang="scss">
.footer-container{
    position: fixed;
    left:0; 
    bottom:0;
    width: 100%;
    .el-footer {
        width: 100%;
        height: 30px;
        font-size: 12px;
        line-height: 16px;
        padding-top: 2px;
        background: #eee;
        text-align: center;
        overflow: hidden;
        position: relative;
        z-index: 100;

        .yw_bq {
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 2px;
        }
    }
}
</style>

